import { render, staticRenderFns } from "./travelMarket.vue?vue&type=template&id=24e0f0fb&scoped=true&"
import script from "./travelMarket.vue?vue&type=script&lang=js&"
export * from "./travelMarket.vue?vue&type=script&lang=js&"
import style0 from "./travelMarket.vue?vue&type=style&index=0&id=24e0f0fb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0f0fb",
  null
  
)

export default component.exports